module.exports = __webpack_public_path__ + "static/media/nft9.5bfbb3a1.jpg";